import PageLayer from "@/Layouts/views/PageLayer";
import ChargebacksLayer from "@DataPages/components/Chargebacks/ChargebacksLayer";

// Icons
import chargeback from "@/assets/icons/common/chargeback.svg";

export default function Chargebacks() {
	return (
		<PageLayer title={"Chargebacks"} icon={chargeback}>
			<ChargebacksLayer />
		</PageLayer>
	);
}
